import { render, staticRenderFns } from "./Imageortext.vue?vue&type=template&id=7e12b163&scoped=true"
import script from "./Imageortext.vue?vue&type=script&lang=js"
export * from "./Imageortext.vue?vue&type=script&lang=js"
import style0 from "./Imageortext.vue?vue&type=style&index=0&id=7e12b163&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e12b163",
  null
  
)

export default component.exports